import type { TwitterAccountSummary } from '@wml-crm/shared';
import { colorForAccount } from '../charts/palette.js';
import { formatSubName } from '../lib/subName.js';

interface Props {
  accounts: TwitterAccountSummary[];
  modelDisplayName: string;
  hidden: Set<string>;
  onToggle: (accountId: string) => void;
  onShowAll: () => void;
  onHideAll: () => void;
}

export function AccountToggler({ accounts, modelDisplayName, hidden, onToggle, onShowAll, onHideAll }: Props) {
  const allHidden = hidden.size === accounts.length && accounts.length > 0;
  const noneHidden = hidden.size === 0;
  return (
    <div className="account-toggler">
      <div className="account-toggler-head">
        <div>
          <div className="section-title" style={{ margin: 0, fontSize: 14 }}>Аккаунты на графике</div>
          <div style={{ fontSize: 12, color: 'var(--text-subtle)', marginTop: 2 }}>
            {accounts.length - hidden.size}/{accounts.length} видимо · клик — скрыть/показать линию
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            className="toggler-mini-btn"
            disabled={noneHidden}
            onClick={onShowAll}
          >
            Показать все
          </button>
          <button
            className="toggler-mini-btn"
            disabled={allHidden}
            onClick={onHideAll}
          >
            Скрыть все
          </button>
        </div>
      </div>
      <div className="account-toggler-list">
        {accounts.map((a) => {
          const isHidden = hidden.has(a.id);
          const color = colorForAccount(a.id);
          return (
            <button
              key={a.id}
              className={`account-toggle-item ${isHidden ? 'hidden' : ''}`}
              onClick={() => onToggle(a.id)}
              title={isHidden ? 'Показать линию' : 'Скрыть линию'}
              aria-pressed={!isHidden}
            >
              <span className="acc-dot" style={{ background: isHidden ? 'transparent' : color, borderColor: color }} />
              <span className="acc-name">{formatSubName(a.slaveName, modelDisplayName) || a.slaveName}</span>
              <span className="acc-count">{a.postCount} постов</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
